export const GET_ARTICLES = "GET_ARTICLES";
export const SHOW_ARTICLE_EDITOR = "SHOW_ARTICLE_EDITOR";
export const CHANGE_ARTICLE = "CHANGE_ARTICLE";
export const CREATE_NEW_ARTICLE = "CREATE_NEW_ARTICLE";
export const REMOVE_NEW_ARTICLE = "REMOVE_NEW_ARTICLE";
export const RESET_ARTICLE_STATE = "RESET_ARTICLE_STATE";
